import { db } from "./initFirebase";
import { USERS, WEBSITE_USERS } from "../utils/consts";
const websiteUsers = db.collection(WEBSITE_USERS);
export const fetchUsers = async () => {
  const response = websiteUsers;
  const { docs } = await response.get();
  const artistList = docs.map((doc) => ({
    id: doc.id,
    ...doc.data(),
  }));
  return artistList;
};



// WEBPACK FOOTER //
// ./src/firebase/users.js